import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
  Paper,
  Typography,
  Switch,
  Box,
  Divider,
  CircularProgress,
  makeStyles,
} from "@material-ui/core";
import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
  root: { padding: 24, maxWidth: 760, margin: "0 auto" },
  header: { marginBottom: 8, fontWeight: 700, color: "#0f172a" },
  sub: { marginBottom: 24, color: "#64748b" },
  card: { border: "1px solid #e5e7eb", borderRadius: 12, overflow: "hidden" },
  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "14px 20px",
  },
  info: { display: "flex", flexDirection: "column" },
  name: { fontWeight: 600, color: "#1e293b" },
  desc: { fontSize: 12.5, color: "#94a3b8" },
  loading: { display: "flex", justifyContent: "center", padding: 40 },
}));

const KEY = "integrationsVisibility";

// Integracoes controlaveis (chave = a mesma usada na pagina de Integracoes)
const INTEGRATIONS = [
  { key: "asaas", name: "Asaas", desc: "Gateway de pagamento" },
  { key: "mercadopago", name: "Mercado Pago", desc: "Gateway de pagamento" },
  { key: "infinitypay", name: "InfinityPay", desc: "Gateway de pagamento" },
  { key: "googlecalendar", name: "Google Calendar", desc: "Agenda" },
  { key: "sheets", name: "Google Sheets", desc: "Planilhas" },
  { key: "flowbuilder", name: "Flow Builder", desc: "Duplicata do menu Automacao > Construtor de Fluxo" },
  { key: "webhook", name: "Webhook", desc: "Integracao HTTP generica" },
  { key: "sgp", name: "SGP", desc: "Sistema de Gestao de Provedor (externo)" },
  { key: "sysclinica", name: "Sys Clinica", desc: "Sistema de clinica (externo)" },
  { key: "sysacademia", name: "Sys Academia", desc: "Sistema de academia (externo)" },
  { key: "hostisites", name: "Hosti Sites", desc: "Sistema de sites (externo)" },
];

// Padrao: nicho desligado, resto ligado
const DEFAULT_HIDDEN = ["sgp", "sysclinica", "sysacademia", "hostisites"];

const IntegracoesDisponiveis = () => {
  const classes = useStyles();
  const [visibility, setVisibility] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/public-settings/${KEY}`);
        let raw = data;
        if (raw && typeof raw === "object" && "value" in raw) raw = raw.value;
        const parsed = raw ? JSON.parse(raw) : {};
        setVisibility(parsed);
      } catch (e) {
        setVisibility({});
      }
    })();
  }, []);

  const isOn = (key) => {
    if (visibility && Object.prototype.hasOwnProperty.call(visibility, key)) {
      return visibility[key] !== false;
    }
    return !DEFAULT_HIDDEN.includes(key);
  };

  const toggle = async (key) => {
    const next = { ...(visibility || {}) };
    next[key] = !isOn(key);
    setVisibility(next);
    setSaving(true);
    try {
      await api.put(`/settings/${KEY}`, { value: JSON.stringify(next) });
      toast.success("Preferencia salva!");
    } catch (e) {
      toast.error("Erro ao salvar. Tente novamente.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box className={classes.root}>
      <Typography variant="h5" className={classes.header}>
        Integrações disponíveis
      </Typography>
      <Typography variant="body2" className={classes.sub}>
        Escolha quais integrações ficam visíveis para os clientes na página de Integrações.
        As desligadas somem do painel deles (você continua vendo tudo).
      </Typography>

      {visibility === null ? (
        <Box className={classes.loading}>
          <CircularProgress size={30} />
        </Box>
      ) : (
        <Paper elevation={0} className={classes.card}>
          {INTEGRATIONS.map((it, idx) => (
            <React.Fragment key={it.key}>
              {idx > 0 && <Divider />}
              <Box className={classes.row}>
                <Box className={classes.info}>
                  <span className={classes.name}>{it.name}</span>
                  <span className={classes.desc}>{it.desc}</span>
                </Box>
                <Switch
                  color="primary"
                  checked={isOn(it.key)}
                  disabled={saving}
                  onChange={() => toggle(it.key)}
                />
              </Box>
            </React.Fragment>
          ))}
        </Paper>
      )}
    </Box>
  );
};

export default IntegracoesDisponiveis;
